import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";

const RejectIcon = (props) => <FontAwesomeIcon icon={["fas", "times"]} {...props}/>

export default RejectIcon;